import bus, { g_Dialog, g_euroDate } from "./main";
import TRR from "./js/Translation.js";
let TR = TRR.lang;
import Vue from "vue";
import DataManager, { ErrorMessage } from "./js/DataManager";
import VueRouter from "vue-router";
import routes from "./routes.js";
import Translation from "./js/Translation.js";

Vue.use(VueRouter);

const BUILD_REAL_SERVER = require("../my_globals").BUILD_REAL_SERVER;

var router = new VueRouter({
  mode: "history", //"hash",
  base: BUILD_REAL_SERVER ? "/" : "/TEST/",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
  routes: routes,
});

router.loadRouteData = function (r, force_choice) {
  // if (r.meta.datatype.require_choice && (force_choice || !r.meta.datatype.datesFromTo || DataManager.data[r.meta.datatype.dataid].length == 0)) {
  if (r.meta.datatype.require_choice && (force_choice || !r.meta.datatype.datesFromTo)) {
    // if (r.meta.datatype == DataManager.DataType.monthly) {
    //   g_Dialog.show(g_Dialog.dialog_types.month_picker, r.meta.datatype.datesFromTo ?? null, null, (yymm) => {
    //     DataManager.DataType.monthly.num_from = yymm;
    //     DataManager.loadData(
    //       DataManager.DataType.monthly,
    //       (err) => {
    //         g_Dialog.close().then(() => {
    //           if (r.instances && r.instances.default && r.instances.default.setTitleAndData) {
    //             r.instances.default.setTitleAndData(r.meta, err);
    //           }
    //         });
    //       },
    //       true,
    //     );
    //   });
    // } else {
      g_Dialog.show(g_Dialog.dialog_types.date_picker, r.meta.datatype.datesFromTo ?? null, null, (dates) => {
        if (dates != null) {
          // EURO!
          if (r.instances && r.instances.default && r.instances.default.setTitleAndData && TR.Locale == Translation.bg.Locale && dates[0].getTime() < g_euroDate.getTime() && dates[1].getTime() > g_euroDate.getTime()) {
            r.instances.default.setTitleAndData(r.meta, new ErrorMessage(ErrorMessage.ERROR_CODE_FAIL, 200, "Периода съдържа данни за обороти и в евро и в лева! Моля изберете период, обхващащ само една валута!", []));
            return;
          } else if (DataManager.isBigUser() && ((r.meta.datatype.access_type == "S" && dates[0].addDays(7) < dates[1]) || (r.meta.datatype.access_type == "Z" && dates[0].addDays(61) < dates[1]))) {
            g_Dialog.show(
              g_Dialog.dialog_types.picker,
              DataManager.getSubscribedDevs(true),
              {
                title: TR.PleaseChooseDevices,
                multiple: true,
                selected: r.meta.datatype.selectedDevs,
                toStringFn: (d) => {
                  return d.Name + " (" + d.sn + "), " + d.Address;
                },
                tooltipFn: (d) => {
                  return d.sn + ", " + d.Address + (d.Technician ?? "");
                },
              },
              (devs) => {
                if (devs != null) {
                  r.meta.datatype.isLoading = true;
                  if (r.meta.datatype.selectedDevs != devs || !r.meta.datatype.datesFromTo || r.meta.datatype.datesFromTo[0].getTime() != dates[0].getTime() || r.meta.datatype.datesFromTo[1].getTime() != dates[1].getTime()) {
                    g_Dialog
                      .show(g_Dialog.dialog_types.loader, null, {
                        message: TR.LoadingOf + " " + r.meta.title + (dates ? +" " + TR.ForPeriod + " " + dates[0].toTremolFpStringShort() + " - " + dates[1].toTremolFpStringShort() : "") + ", " + TR.PleaseWait,
                      })
                      .then(() => {
                        DataManager.loadData(
                          r.meta.datatype,
                          (err) => {
                            g_Dialog.close().then(() => {
                              if (r.instances && r.instances.default && r.instances.default.setTitleAndData) {
                                r.instances.default.setTitleAndData(r.meta, err);
                              }
                            });
                          },
                          true,
                          dates[0],
                          dates[1],
                          devs,
                        );
                      });
                  } else {
                    if (r.instances && r.instances.default && r.instances.default.setTitleAndData) {
                      r.instances.default.setTitleAndData(r.meta, new ErrorMessage(ErrorMessage.ERROR_CODE_OK, 200, null, []));
                    }
                  }
                  r.meta.datatype.selectedDevs = devs;
                } else {
                  if (r.instances && r.instances.default && r.instances.default.setTitleAndData) {
                    r.instances.default.setTitleAndData(r.meta, new ErrorMessage(ErrorMessage.ERROR_CODE_FAIL, 200, TR.DevicesNotChosen, []));
                  }
                }
              },
            );
          } else {
            r.meta.datatype.isLoading = true;
            if (!r.meta.datatype.datesFromTo || r.meta.datatype.datesFromTo[0].getTime() != dates[0].getTime() || r.meta.datatype.datesFromTo[1].getTime() != dates[1].getTime()) {
              g_Dialog
                .show(g_Dialog.dialog_types.loader, null, {
                  message: TR.LoadingOf + " " + r.meta.title + (dates ? " " + TR.ForPeriod + " " + dates[0].toTremolFpStringShort() + " - " + dates[1].toTremolFpStringShort() : "") + ", " + TR.PleaseWait,
                })
                .then(() => {
                  DataManager.loadData(
                    r.meta.datatype,
                    (err) => {
                      g_Dialog.close().then(() => {
                        if (r.instances && r.instances.default && r.instances.default.setTitleAndData) {
                          r.instances.default.setTitleAndData(r.meta, err);
                        }
                      });
                    },
                    true,
                    dates[0],
                    dates[1],
                    DataManager.data[DataManager.DataType.devices.id].slice(),
                  );
                });
            } else {
              if (r.instances && r.instances.default && r.instances.default.setTitleAndData) {
                r.instances.default.setTitleAndData(r.meta, new ErrorMessage(ErrorMessage.ERROR_CODE_OK, 200, null, []));
              }
            }
          }

          r.meta.datatype.datesFromTo = dates;
          // if (!r.meta.datatype.datesFromTo) {
          //   Object.defineProperty(r.meta.datatype, "datesFromTo", {
          //     configurable: true,
          //     enumerable: true,
          //   });
          // }
          // if (!r.meta.datatype.datesFromTo) {
          //   r.meta.datatype.datesFromTo = [null, null]
          // }
          // r.meta.datatype.datesFromTo[0] = dates[0];
          // r.meta.datatype.datesFromTo[1] = dates[1];
        } else {
          // g_Dialog.close().then(() => {
          if (r.instances && r.instances.default && r.instances.default.setTitleAndData) {
            if (r.meta.datatype.datesFromTo) {
              r.instances.default.setTitleAndData(r.meta, new ErrorMessage(ErrorMessage.ERROR_CODE_OK, 200, null, []));
            } else {
              r.instances.default.setTitleAndData(r.meta, new ErrorMessage(ErrorMessage.ERROR_CODE_FAIL, 200, TR.PeriodNotChosen, []));
            }
          }
          // });
        }
      });
    // }
  } else {
    r.meta.datatype.isLoading = true;
    g_Dialog
      .show(g_Dialog.dialog_types.loader, null, {
        message: TR.LoadingOf + " " + r.meta.title + ", " + TR.PleaseWait,
      })
      .then(() => {
        DataManager.loadData(
          r.meta.datatype,
          (err) => {
            g_Dialog.close().then(() => {
              Vue.nextTick(() => {
                if (r.instances && r.instances.default && r.instances.default.setTitleAndData) {
                  r.instances.default.setTitleAndData(r.meta, err);
                }
              });
            });
          },
          r.meta.force_load == true,
          r.meta.datatype.datesFromTo ? r.meta.datatype.datesFromTo[0] : undefined,
          r.meta.datatype.datesFromTo ? r.meta.datatype.datesFromTo[1] : undefined,
        );
      });
  }
};

router.beforeEach((to, from, next) => {
  TR = TRR.lang;
  if (to && to.meta && to.meta.internal && (Object.keys(to.query).length != 1 || to.query["internal"] != "true")) {
    next("/login");
    return;
  }
  from.matched.forEach((r) => {
    Vue.nextTick(() => {
      try {
        if (r.instances && r.instances.default && r.instances.default.setFocus) {
          r.instances.default.setFocus(false);
        }
      } catch {
        /**ignore */
      }
    });
    //next();
  });
  var found = false;
  if (to.matched.length == 0) {
    // console.log("no match ! " + to.path);
    router.push({ path: "/" + TR.Locale + "/settings" }).catch(() => {});
  } else {
    to.matched.forEach((r) => {
      if (r.path == "/login" && DataManager.getData(DataManager.DataType.user, true) && DataManager.getData(DataManager.DataType.user, true).userName) {
        alert(TR.DataIsRefreshingByItself);
        found = true;
        next(false);
        return;
      } else if (r.meta && r.meta.require_login && r.path != "/login" && r.path != "/landing" && (!DataManager.getData(DataManager.DataType.user, true) || DataManager.getData(DataManager.DataType.user, true) instanceof Array)) {
        DataManager.__clean();
        found = true;
        next("/login");
        return;
      } else if (r.meta) {
        if (r.path != "/MainContent") {
          bus.$emit(bus.EVENT_AddTab_In_MainContent, r.name);
          r.meta.route = r;
          if (r.meta.datatype) {
            router.loadRouteData(r, false);
          } else {
            Vue.nextTick(() => {
              if (r.instances && r.instances.default && r.instances.default.setTitleAndData) {
                r.instances.default.setTitleAndData(r.meta, new ErrorMessage(ErrorMessage.ERROR_CODE_OK, 200, null, []));
              }
            });
          }
        }
      }
      found = true;
      next();
    });
  }
  if (!found) next();
});

router.afterEach((to) => {
  to.matched.forEach((r) => {
    Vue.nextTick(() => {
      if (r.instances && r.instances.default && r.instances.default.setFocus) {
        r.instances.default.setFocus(true);
      }
    });
  });
});

export default router;
